import { graphql } from "react-relay";
import "@components/smart-hold-sync/SmartHoldSync.gql";

export const fragments = {
  org: graphql`
    fragment OnboardingFocusTimeSyncStep_org on Org {
      ...SmartHoldSync_org
      id
      shadowCalendarSettingsErrorable {
        __typename
        ... on ShadowCalendarSettings {
          focusTimeSyncEnabled
          focusTimeSyncAll
        }
      }
    }
  `,
};
